import { Pagination } from 'types'

export const SALARY_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 15,
  sort: {
    by: 'id',
    order: 'DESC',
  },
}
